module.exports = __webpack_public_path__ + "static/media/5k_website_logo_diamond_yord.debbf670.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/5k_website_logo_diamond_yord.jpg
// module id = 95
// module chunks = 0